import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAppIcBefehl33 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Form",
	xmlns: "http://www.w3.org/2000/svg",
	width: 64,
	height: 64,
	viewBox: "0 0 64 64",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".red{fill:#ec0016;}.black{fill:currentColor;}" }) }), /* @__PURE__ */ _jsxs("g", {
		id: "Command_33",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Arrow",
			className: "black",
			d: "M49.19,32h-14.38c-2.1,0-3.81-1.71-3.81-3.81v-14.38c0-2.1,1.71-3.81,3.81-3.81h14.38c2.1,0,3.81,1.71,3.81,3.81v14.38c0,2.1-1.71,3.81-3.81,3.81ZM34.81,12c-1,0-1.81.81-1.81,1.81v14.38c0,1,.81,1.81,1.81,1.81h14.38c1,0,1.81-.81,1.81-1.81v-14.38c0-1-.81-1.81-1.81-1.81h-14.38ZM35.57,21.57l5.05,5.05c.51.51,1.38.15,1.38-.57v-2.05h6c.55,0,1-.45,1-1v-4c0-.55-.45-1-1-1h-6v-2.05c0-.72-.87-1.08-1.38-.57l-5.05,5.05c-.32.32-.32.83,0,1.15Z"
		}), /* @__PURE__ */ _jsxs("g", {
			id: "ICE_Sideview",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "red",
					d: "M37,49H12c-.55,0-1-.45-1-1s.45-1,1-1h25c.55,0,1,.45,1,1s-.45,1-1,1Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M28,53H12c-.55,0-1-.45-1-1s.45-1,1-1h16c9,0,9-2.52,9-4.03,0-2.39-2.66-5.91-6.62-8.76-4.56-3.41-9.63-5.21-14.69-5.21h-3.69c-.55,0-1-.45-1-1s.45-1,1-1h3.69c5.49,0,10.98,1.93,15.88,5.59,4.58,3.3,7.44,7.28,7.44,10.38,0,4.23-3.29,6.03-11,6.03Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "black",
					d: "M24.76,42.78s-.1,0-.15-.01l-.5-.07c-3.2-.47-6.48-.7-10.02-.7h-2.09c-.55,0-1-.45-1-1s.45-1,1-1h2.09c3.64,0,7.01.24,10.31.72h0l.94-.94c-3.08-1.82-6.66-2.78-10.34-2.78h-3c-.55,0-1-.45-1-1s.45-1,1-1h3c4.04,0,7.97,1.06,11.36,3.06l1.11.66c.27.16.44.43.48.74.04.31-.07.61-.29.83l-2.21,2.21c-.19.19-.44.29-.71.29Z"
				})
			]
		})]
	})]
});
export default SvgAppIcBefehl33;
